// @/services/CoursesClient.js
import { CandyClient } from "@cabysis/candy-client";
import { getToken } from "@/utilities/storage";
import { BACK_END_URL } from "@/utilities/config";

const coursesOptions = {
  baseUrl: `${BACK_END_URL}/course`, // Changed from '/courses' to '/course' to match backend
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  getToken: () => getToken(),
};

export class CoursesClient extends CandyClient {
  constructor() {
    super(coursesOptions);
  }

  // Create
  async createCourse(dto) {
    const token = getToken();
  
    return this.post("/create", dto, {
      customHeaders: { Authorization: `Bearer ${token}` ,
      'Content-Type': 'application/json'
      }
    });
  }
  

  // Read
  async getAllCourses() {
    return this.get("/list");
  }

  async getCourseById(id) {
    return this.get(`/id/${id}`);
  }
  
  async getInstructorCoursesById() {
    return this.get(`/instructor`, {
      customHeaders: { Authorization: `Bearer ${getToken()}` }
    });  
  }

  // Update
  async updateCourse(id, dto) {
    return this.put(`/update/${id}`, dto);
  }

  // Delete
  async deleteCourse(id) {
    return this.delete(`/delete/${id}`);
  }

}